<template>
    <v-card
        style="min-height: 300px; position: relative; height: 100%"
        class="download"
    >
        <v-overlay absolute :opacity="0.5" z-index="100000" v-if="loading">
            <v-progress-circular indeterminate size="64">
                Loading...
            </v-progress-circular>
        </v-overlay>
        <v-form>
            <v-toolbar
                flat
                dark
                :class="screen === 'mobile' ? '' : 'pr-10 pl-10'"
                color="#2196F3"
            >
                <v-toolbar-title>
                    {{ $t("modals.download.title") }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="$emit('popup_close')">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-container
                class="pt-5"
                :class="screen === 'mobile' ? '' : 'pr-15 pl-15 pt-0'"
            >
                <v-row>
                    <v-col class="pt-0 popup__card">
                        <v-card
                            class="profile__card"
                            max-height="265"
                            min-height="265"
                        >
                            <v-card-title class="profile__card-title pl-10">
                                {{ $t("modals.download.subtitle_1") }}
                            </v-card-title>
                            <v-card-text
                                :class="screen === 'mobile' ? '' : 'pl-0 pr-0'"
                            >
                                <vue-custom-scrollbar
                                    class="scroll-area"
                                    :class="
                                        screen === 'mobile'
                                            ? 'pr-5 pl-5'
                                            : 'pr-5 pl-10'
                                    "
                                    :settings="scrlSet"
                                >
                                    <v-radio-group
                                        class="mt-0"
                                        v-model="activeTemplate"
                                    >
                                        <v-radio
                                            v-for="type in docTypes"
                                            :key="type.id"
                                            :label="type.name"
                                            :value="type.id"
                                        />
                                    </v-radio-group>
                                </vue-custom-scrollbar>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col class="pt-0 popup__card">
                        <v-card
                            class="profile__card"
                            max-height="265"
                            min-height="265"
                        >
                            <v-card-title
                                class="profile__card-title"
                                :class="screen === 'mobile' ? '' : 'pl-10'"
                            >
                                {{ $t("modals.download.subtitle_2") }}
                            </v-card-title>
                            <v-card-text
                                :class="screen === 'mobile' ? '' : 'pl-0 pr-0'"
                            >
                                <vue-custom-scrollbar
                                    class="scroll-area"
                                    :class="
                                        screen === 'mobile'
                                            ? 'pr-5 pl-5'
                                            : 'pr-5 pl-10'
                                    "
                                    :settings="scrlSet"
                                >
                                    <div v-html="activeTemplateText" />
                                </vue-custom-scrollbar>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-tooltip z-index="1000" bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <button
                            class="btn btn--fill ml-auto"
                            v-bind="attrs"
                            v-on="on"
                            dark
                            @click.prevent="sendDownloadRequest"
                        >
                            <span>{{ $t("modals.download.apply") }}</span>
                        </button>
                    </template>
                    <span>{{ $t("tooltips.applyDownload") }}</span>
                </v-tooltip>
            </v-container>
        </v-form>
    </v-card>
</template>
<script>
export default {
    name: "Download",
    props: {
        screen: String,
        scrlSet: Object,
        activeItem: Object,
        date: Object,
    },
    data: () => ({
        docTypes: [],
        loading: true,
        activeTemplate: null,
        documentData: [],
        articles: [],
    }),
    async mounted() {
        let selectedArticles = this.$store.state.download.selectedArticles
            .length;
        let selectedTopics = this.$store.state.download.selectedTopics.length;
        if (selectedArticles) {
            this.articles.concat(selectedArticles);
        }
        if (selectedTopics) {
            this.articles.concat(selectedTopics);
        }

        this.docTypes = await this.$store.dispatch("fetchDocTypes");
        this.loading = false;
        this.activeTemplate = this.docTypes[0].id;
    },
    computed: {
        /**
         * watch by a description text
         * */
        activeTemplateText: function () {
            if (this.docTypes.length !== 0) {
                return this.getTemplateById(this.activeTemplate).description;
            }
            return "Описание отсутствует";
        },
    },
    methods: {
        /**
         * get template obj by ID
         * */
        getTemplateById(id) {
            return this.docTypes.filter(
                (type) => type.id === this.activeTemplate
            )[0];
        },
        /**
         * download file func
         * */
        download(data) {
            let downloadedTemplate = this.getTemplateById(this.activeTemplate);

            let today = new Date().toLocaleDateString("ru-RU", {
                year: "numeric",
                month: "2-digit",
                day: "2-digit",
                hour: "2-digit",
                minute: "2-digit",
                second: "2-digit",
            });
            let date = today.split(", ")[0];
            let time = today.split(", ")[1];
            let transformDate = date
                .split(".")
                .splice(0, 2)
                .concat(
                    today
                        .split(", ")[0]
                        .split(".")
                        [today.split(", ")[0].split(".").length - 1].split("")
                        .splice(2)
                        .join("")
                )
                .join(".");
            let transformTime = time.split(":").splice(0, 2).join(":");

            let transformed = `${transformDate}(${transformTime})`;
            
            let name = this.activeItem ? `${this.activeItem.name}_${transformed}` : `Export_${transformed}`;
            let type = downloadedTemplate.name.split(".")[1];
            let fileName = `${name}.${type}`;
            let element = document.createElement("a");
            element.setAttribute(
                "href",
                "data:attachment/csv;base64;charset=utf-8," +
                    encodeURIComponent(data)
            );

            element.setAttribute("download", fileName);

            element.style.display = "none";
            document.body.appendChild(element);

            element.click();

            this.$toastr.success(`${name} ${this.$t("messages.successfullySaved")}`)
            document.body.removeChild(element);

        },
        getArticlesId() {
            return this.articles.map((article) => article.id);
        },
        async sendDownloadRequest() {
            this.loading = true;
            let data = this.activeTemplate;
            if (this.activeItem) {
                if (this.activeItem.type === "summary") {
                    let obj = {
                        digestName: this.activeItem.name,
                        startDate: `${this.date.firstDate}, ${this.date.firstTime}:00`,
                        endDate: `${
                            this.date.lastDate
                                ? this.date.lastDate
                                : this.date.firstDate
                        }, ${this.date.lastTime}:00`,
                        templateID: String(data),
                    };
                    this.documentData = await this.$store.dispatch(
                        "downloadDigets",
                        obj
                    )

                    this.download(this.documentData);
                } else {
                    let obj = {
                        reportName: this.activeItem.name,
                        templateID: String(data),
                    };
                    this.documentData = await this.$store.dispatch(
                        "GenerateReport",
                        obj
                    );
                    this.download(this.documentData);
                }
            } else {
                this.documentData = await this.$store.dispatch(
                    "getDocumentData",
                    data
                );
                this.download(this.documentData);
            }
            this.loading = false;
            this.$emit("popup_close");
        },
    },
};
</script>
<style scoped lang="scss">
.download {
    form {
        background: #fff;
    }
}
</style>